import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import BottomSheet from './BottomSheet'

const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

// Desktop: modal centrado en pantalla con fondo oscuro
// Mobile: bottom sheet
export default function ResponsiveModal({ isOpen, onClose, title, maxWidthClass = 'max-w-[320px]', headerAction, children }) {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches
  )

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)')
    const handler = e => setIsDesktop(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!isOpen) { setShow(false); return }
    let raf1, raf2
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => setShow(true))
    })
    return () => { cancelAnimationFrame(raf1); cancelAnimationFrame(raf2) }
  }, [isOpen])

  // Bloquea el scroll del fondo mientras el modal de escritorio está abierto.
  useEffect(() => {
    if (!isOpen || !isDesktop) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [isOpen, isDesktop])

  function handleFadeClose() {
    setShow(false)
    setTimeout(onClose, 200)
  }

  if (!isOpen) return null

  if (isDesktop) {
    return createPortal(
      <>
        <div
          onClick={handleFadeClose}
          className="fixed inset-0 z-1001 bg-black/40"
          style={{ opacity: show ? 1 : 0, transition: 'opacity 0.2s ease' }}
        />
        <div className="fixed inset-0 z-1002 flex items-center justify-center px-4 pointer-events-none">
          <div
            className={`pointer-events-auto w-full ${maxWidthClass} bg-white rounded-xl flex flex-col`}
            style={{
              boxShadow: '0 4px 32px rgba(0,0,0,0.13)',
              opacity: show ? 1 : 0,
              transition: 'opacity 0.2s ease'
            }}
          >
            <div className="flex items-center justify-end gap-2 px-3 pt-3">
              {headerAction}
              <button
                onClick={handleFadeClose}
                className="p-1 bg-transparent border-none cursor-pointer focus:outline-none text-woperty-dark"
              >
                <CloseIcon />
              </button>
            </div>

            {typeof children === 'function' ? children(isDesktop) : children}
          </div>
        </div>
      </>,
      document.body
    )
  }

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={title} headerAction={headerAction}>
      {typeof children === 'function' ? children(isDesktop) : children}
    </BottomSheet>
  )
}
